"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoodooEffectHandler = exports.HoodooEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class HoodooEffectArgs {
    constructor(damagePerTurn) {
        this.damagePerTurn = damagePerTurn;
        this.__type = EffectType_1.EffectType.Hoodoo;
        this.__typeName = "Hoodoo";
        this.name = "Hoodoo";
        this.harmful = true;
    }
}
exports.HoodooEffectArgs = HoodooEffectArgs;
let HoodooEffectHandler = class HoodooEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            damageAmountPerTurn: state.args.damagePerTurn,
            targetId: state.targetId
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_Hoodoo_OnTurnStarted", scriptArgs));
        container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.DamnedEffectArgs(),
            duration: Duration_1.Duration.Permanent,
            onApplied: (sequence) => {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(state.targetId, "feet"), "EngulfingDarkness"));
            }
        });
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
HoodooEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Hoodoo)
], HoodooEffectHandler);
exports.HoodooEffectHandler = HoodooEffectHandler;
